import { IIconProps } from "~/types";
const TrashIcon = (props:IIconProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m14.25 5.25-.65 9.107a1.5 1.5 0 0 1-1.497 1.393H5.897A1.5 1.5 0 0 1 4.4 14.357L3.75 5.25m10.5 0h-3m3 0H15m-11.25 0H3m.75 0h3m.75 3v4.5m3-4.5v4.5m.75-7.5V3a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75v2.25m4.5 0h-4.5"
      stroke="#DE390B"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TrashIcon;
